module.exports = __webpack_public_path__ + "static/media/wa10x_desktop_login.d98f1892.png";